module.exports = __webpack_public_path__ + "static/media/global.dde7f1c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/global.svg
// module id = 113
// module chunks = 0